import { SET_SESSION_ID } from '../../actionTypes';

const initialState = null;

export default function sessionId(state = initialState, action) {
    switch (action.type) {
        case SET_SESSION_ID:
            // Never return undefined — Redux forbids it and crashes the store.
            if (action.payload?.sessionId === undefined) return state;
            return action.payload.sessionId;
        default:
            return state;
    }
}
